import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type AccountStore } from 'pages/settings/pages/personal/pages/account/store/accountStore'

type IUploadImageModalActionsProps = {
  store: AccountStore
}

export const UploadPhotoModalActions = observer(({ store }: IUploadImageModalActionsProps) => {
  const { onCloseModal, handleApplyUploadImage, loading } = store

  return (
    <>
      <Button
        fullWidth
        text={'Cancel'}
        onClick={onCloseModal}
        typeBtn={'contained'}
        size={'medium'}
        contained={'secondary'}
      />
      <Button
        fullWidth
        text={'Apply'}
        onClick={handleApplyUploadImage}
        disabled={loading}
        loading={loading}
      />
    </>
  )
})
